export { usePatientDetails } from "./use-patient-details";
export { useUpdatePatient } from "./use-update-patient";
export { useCreatePatient } from "./use-create-patient";